// console.* é autorizado AQUI e só aqui (espelha o worker). Override via eslint.config.js.
import { redact } from '@multimod/shared';
import type { Logger, LogContext, LogLevel } from '@multimod/shared';

const LEVEL_RANK: Record<LogLevel, number> = {
  debug: 10, info: 20, warn: 30, error: 40,
};

function serializeError(err: unknown): Record<string, unknown> {
  if (err instanceof Error) return { name: err.name, message: err.message, stack: err.stack };
  return { value: String(err) };
}

interface Opts { minLevel: LogLevel; baseContext: LogContext }

class WebJsonLogger implements Logger {
  constructor(private readonly opts: Opts) {}

  private emit(level: LogLevel, msg: string, ctx?: LogContext, err?: unknown): void {
    if (LEVEL_RANK[level] < LEVEL_RANK[this.opts.minLevel]) return;
    const merged: Record<string, unknown> = {
      level, msg, timestamp: new Date().toISOString(),
      ...(redact({ ...this.opts.baseContext, ...ctx }) as Record<string, unknown>),
    };
    if (err !== undefined) merged.err = serializeError(err);
    console.log(JSON.stringify(merged));
  }

  debug(msg: string, ctx?: LogContext): void { this.emit('debug', msg, ctx); }
  info(msg: string, ctx?: LogContext): void { this.emit('info', msg, ctx); }
  warn(msg: string, ctx?: LogContext): void { this.emit('warn', msg, ctx); }
  error(msg: string, err?: unknown, ctx?: LogContext): void { this.emit('error', msg, ctx, err); }

  child(ctx: LogContext): Logger {
    return new WebJsonLogger({ minLevel: this.opts.minLevel, baseContext: { ...this.opts.baseContext, ...ctx } });
  }
}

export function createLogger(opts: { minLevel?: LogLevel; baseContext?: LogContext } = {}): Logger {
  return new WebJsonLogger({ minLevel: opts.minLevel ?? 'info', baseContext: opts.baseContext ?? {} });
}
